import React, { useState } from "react";
import { v4 as uuid } from "uuid";

import { StageCapacity, DeleteCapacityModal, EditCapacityModal } from "Venues/components";
import { IStageCapacity } from "Venues/types";

interface CreateStageCapacityProps {
  capacities: IStageCapacity[];
  setCapacities: React.Dispatch<React.SetStateAction<IStageCapacity[]>>;
}

export const CreateStageCapacity: React.FC<CreateStageCapacityProps> = ({
  capacities,
  setCapacities,
}) => {
  const [selectedCapacity, setSelectedCapacity] = useState<IStageCapacity>();
  const [showDeleteCapacityModal, setShowDeleteCapacityModal] = useState(false);
  const [showEditCapacityModal, setShowEditCapacityModal] = useState(false);

  const deleteCapacity = (id?: string) => {
    if (id) {
      setCapacities(capacities => capacities.filter(capacity => capacity.id !== id));
      setShowDeleteCapacityModal(false);
    }
  };
  const editCapacity = (newCapacity: IStageCapacity, id?: string) => {
    if (id) {
      setCapacities(capacities =>
        capacities.map(oldCapacity =>
          oldCapacity.id === id ? { ...newCapacity, id } : oldCapacity
        )
      );
      setShowEditCapacityModal(false);
    }
  };

  const addCapacity = (capacity: IStageCapacity) => {
    setCapacities(capacities => [...capacities, { ...capacity, id: uuid() }]);
  };

  return (
    <>
      {showDeleteCapacityModal && (
        <DeleteCapacityModal
          handleClose={() => setShowDeleteCapacityModal(false)}
          capacity={selectedCapacity}
          handleDelete={deleteCapacity}
        />
      )}
      {showEditCapacityModal && (
        <EditCapacityModal
          handleClose={() => setShowEditCapacityModal(false)}
          capacity={selectedCapacity}
          handleEdit={editCapacity}
        />
      )}

      <StageCapacity
        capacities={capacities}
        addCapacity={addCapacity}
        handleDelete={(capacity: IStageCapacity) => {
          setSelectedCapacity(capacity);
          setShowDeleteCapacityModal(true);
        }}
        handleEdit={(capacity: IStageCapacity) => {
          setSelectedCapacity(capacity);
          setShowEditCapacityModal(true);
        }}
        resetForm={true}
      />
    </>
  );
};
